import React, { useState } from 'react'
import * as UIcons from '@iconscout/react-unicons'
import StatCard from 'components/DetailWidgets/StatCard'
import MultiLineChartCard from 'components/DetailWidgets/MultiLineChartCard'
import TabTable from '../TabTable'

const COLUMNS = [
  { key: 'rank', label: 'Rank' },
  { key: 'user', label: 'User' },
  { key: 'quizPlays', label: 'Quiz Plays' },
  { key: 'avgScore', label: 'Avg Score' },
  { key: 'correctRate', label: 'Correct Rate' },
  { key: 'pointsEarned', label: 'Points Earned' }
]

export default function QuizTab({ campaign }) {
  const { quiz } = campaign
  const [chartTab, setChartTab] = useState(quiz.performance.tabs[0].key)

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {
          quiz.stats.map((stat) => (
            <StatCard key={stat.key} icon={UIcons.UilQuestionCircle} label={stat.label} value={stat.value} trend={stat.trend} tone={stat.tone} />
          ))
        }
      </div>

      <MultiLineChartCard
        title="Quiz Performance"
        series={quiz.performance.seriesByTab[chartTab]}
        tabs={quiz.performance.tabs}
        activeTab={chartTab}
        onTabChange={setChartTab}
      />

      <TabTable columns={COLUMNS} rows={quiz.rows} searchPlaceholder="Search by name, phone, user ID" searchKeys={['user']} />
    </div>
  )
}
